var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{},[(_vm.isAllowed())?_c('GlobalNavMobile'):_vm._e(),_c('NotificationDrawer'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }